import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { Datepicker, FormWidgets } from "../../../Constant";
import DefaultCalendar from "./DefaultCalendar";
import BootstrapCalendar from "./BootstrapCalendar";
import DatesPicker from "./DatesPicker";
import TimePicker from "./TimePicker";

const DatepickerContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={Datepicker} parent={FormWidgets} title={Datepicker} />
      <Container fluid>
        <Row>
          <DefaultCalendar />
          <BootstrapCalendar />
          <DatesPicker />
          <TimePicker/>
        </Row>
      </Container>
    </>
  );
};

export default DatepickerContainer;
